import { Box, Typography, Paper, Accordion, AccordionSummary, AccordionDetails, Button, styled } from "@mui/material";

export const MainContainer = styled(Box)`
  background-color: #fff;
  min-height: 100vh;
  min-height: 100dvh; /* Use dynamic viewport height for better mobile support */
  padding-bottom: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  /* Ensure smooth scrolling on all devices */
  -webkit-overflow-scrolling: touch;
`;

export const ContentContainer = styled(Box)`
  max-width: 800px;
  margin: 0 auto;
  padding: 16px;
  padding-top: 32px;
  padding-bottom: 120px; /* Increased from 32px to ensure button accessibility */
  
  /* Responsive padding for different screen sizes */
  @media (max-width: 600px) {
    padding: 12px;
    padding-top: 24px;
    padding-bottom: 140px; /* Extra padding on mobile for safe area */
  }
  
  @media (max-height: 700px) {
    /* For shorter screens, reduce top padding but maintain bottom padding */
    padding-top: 16px;
    padding-bottom: 120px;
  }
`;

export const PageTitle = styled(Typography)`
  font-weight: bold;
  color: var(--primary-blue);
  margin-bottom: 32px;
  text-align: center;
  font-size: 2rem;
`;

export const LocationPaper = styled(Paper)`
  padding: 24px;
  margin-bottom: 32px;
  border-radius: 8px;
  background-color: #f5f8ff;
  border: 1px solid #e0e0e0;
`;

export const LocationTitle = styled(Typography)`
  font-weight: bold;
  margin-bottom: 16px;
  font-size: 1.25rem;
`;

export const LocationText = styled(Typography)`
  margin-bottom: 8px;
`;

export const StyledAccordion = styled(Accordion)`
  margin-bottom: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px !important;
  &:before {
    display: none;
  }
  &.Mui-expanded {
    margin: 0 0 16px 0;
  }
`;

export const StyledAccordionSummary = styled(AccordionSummary)`
  border-radius: 8px;
  &.Mui-expanded {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const AccordionTitleContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const AccordionTitle = styled(Typography)`
  font-weight: bold;
  font-size: 1.25rem;
`;

export const DetailsGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
`;

export const DetailItemContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const IconContainer = styled(Box)`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DetailLabelText = styled(Typography)`
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.875rem;
`;

export const DetailValueText = styled(Typography)`
  font-weight: 500;
`;

export const DetailContentText = styled(Typography)`
  font-weight: 400;
  line-height: 1.5;
`;

export const ButtonsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const BackToEditButton = styled(Button)`
  color: var(--primary-blue);
  text-decoration: none;
  font-weight: 500;
  &:hover {
    text-decoration: underline;
    background-color: transparent;
  }
`; 